import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IInitialState {
	searchValue: string;
	sortDirection: boolean | null;
	sortFieldName: string | null;
}

const initialState: IInitialState = {
	searchValue: '',
	sortDirection: false,
	sortFieldName: null,
};

const dashboardPORequestsTable = createSlice({
	name: 'dashboardPORequestsTable',
	initialState,
	reducers: {
		setSort: (
			state,
			action: PayloadAction<{
				sortDirection: boolean | null;
				sortFieldName: string | null;
			}>,
		) => {
			state.sortDirection = action.payload.sortDirection;
			state.sortFieldName = action.payload.sortFieldName;
		},
		setSearchValue: (state, action: PayloadAction<{ searchValue: string }>) => {
			state.searchValue = action.payload.searchValue;
		},
		resetDashboardRequestsTable: () => initialState,
	},
});

export const {
	resetDashboardRequestsTable,
	setSearchValue,
	setSort,
} = dashboardPORequestsTable.actions;

export default dashboardPORequestsTable.reducer;
